import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const AddPatientDetails = async (payload) => {
  const url = `${API_CONSTANTS.ADD_PATIENT_DETAILS}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const getGenderDropDown = async () => {
  const url = `${API_CONSTANTS.GENDER_DROPDOWN}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetPatientDetails = async (payload) => {
  const url = `${API_CONSTANTS.GET_PATIENT_DETAILS}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetPatientById = async (id) => {
  const url = `${API_CONSTANTS.GET_PATIENT_BY_ID}?patientId=${id}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const UpdatePatientDetails = async (payload, patientId) => {
  const url = `${API_CONSTANTS.UPDATE_PATIENT_DETAILS}?patientId=${patientId}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const DeletePatientById = async (patientid) => {
  const url = `${API_CONSTANTS.DELETE_PATIENT_BY_ID}?patientid=${patientid}`;
  return fetchLoginCall(url, API_METHODS.DELETE);
};

export const AddPatientNote = async (payload) => {
  const url = `${API_CONSTANTS.ADD_PATIENT_NOTE}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetPatientAllNote = async (patientId) => {
  const url = `${API_CONSTANTS.GET_PATIENT_NOTE}?patientId=${patientId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const DeletePatientNoteById = async (noteId) => {
  const url = `${API_CONSTANTS.DELETE_PATIENT_NOTE_BY_ID}?noteId=${noteId}`;
  return fetchLoginCall(url, API_METHODS.DELETE);
};

export const GetSessionDetail = async (patientId, payload) => {
  const url = `${API_CONSTANTS.GET_SESSION_DETAIL}?patientId=${patientId}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const DeleteSessionDetailById = async (referenceId) => {
  const url = `${API_CONSTANTS.DELETE_SESSION_DETAIL}?referenceId=${referenceId}`;
  return fetchLoginCall(url, API_METHODS.DELETE);
};

export const GetCalendarData = async (patientId) => {
  const url = `${API_CONSTANTS.GET_CALENDAR_DATA}?patientId=${patientId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetReferenceData = async (referenceId) => {
  const url = `${API_CONSTANTS.GET_REFERENCE_DATA}?referenceId=${referenceId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const CsvDownloadHandler = async (id) => {
  const url = `${API_CONSTANTS.CSV_DOWNLOAD_HANDLER}?sessionId=${id}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const ProcessRawCSVFile = async (sessionId) => {
  const url = `${API_CONSTANTS.PROCESS_RAW_CSV_FILE}?sessionId=${sessionId}`;
  return fetchLoginCall(url, API_METHODS.POST);
};

export const GetJobStatus = async (sessionId) => {
  const url = `${API_CONSTANTS.GET_JOB_STATUS}?sessionId=${sessionId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetAllPatientSuperAdminwithoutId = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_PATIENTS_SUPERADMIN}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllPatientSuperAdmin = async (payload, id) => {
  const url = `${API_CONSTANTS.GET_ALL_PATIENTS_SUPERADMIN}?healthProfessionalId=${id}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllPatientDetailsHealthProfessional = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_PATIENTS_HP}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};
